import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Dashboard,
  Packages,
  Threeline,
  plusgray,
  Bookings,
  Ruppe2,
  Headset,
  Logo,
  Rightarrow,
  Downarrow2,
  Setting,
} from "../../assests/ExportImageIcon";

import "./sidebar.css";

const HolidayPackageSidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openMenu, setOpenMenu] = useState(null);

  const handleClick = (name, route = null) => {
    if (route) navigate(route);
  };

  const handleDropdownClick = (name) => {
    if (collapsed) return;

    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const isOpen = (name) => openMenu === name;

  const isActive = (name) => {
    switch (name) {
      case "holiday-dashboard":
        return (
          location.pathname === "/holiday-dashboard" ||
          location.pathname.startsWith("/holiday-dashboard/")
        );

      case "holiday-packages":
        return (
          location.pathname === "/holiday-packages" ||
          location.pathname.startsWith("/holiday-packages/") ||
          location.pathname.startsWith("/holiday-packages-detail")
        );

      case "create-holiday-package":
        return (
          location.pathname === "/create-holiday-package" ||
          location.pathname.startsWith("/create-holiday-package/")
        );

      case "holiday-bookings":
        return (
          location.pathname === "/holiday-bookings" ||
          location.pathname.startsWith("/holiday-booking-detail")
        );

      case "holiday-revenue":
        return (
          location.pathname === "/holiday-revenue" ||
          location.pathname.startsWith("/holiday-revenue/")
        );
      case "holiday-settings":
        return (
          location.pathname === "/holiday-settings" ||
          location.pathname.startsWith("/holiday-settings/")
        );
      case "support-tickets":
        return (
          location.pathname === "/requests" ||
          location.pathname.startsWith("/requests/")
        );

      default:
        return false;
    }
  };

  const isPackagesActive =
    isActive("holiday-packages") || isActive("create-holiday-package");

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div onClick={() => navigate("/holiday-dashboard")} className="logo">
        <img
          src={Logo}
          alt="Travel Booking"
          style={{
            maxHeight: "48px",
            maxWidth: "100%",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      </div>

      <ul className="menu">
        {/* Holiday Package Vendor */}
        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("holiday-dashboard") ? "active" : ""
            }`}
            onClick={() =>
              handleClick("holiday-dashboard", "/holiday-dashboard")
            }
          >
            <img src={Dashboard} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Dashboard</span>}
          </div>
        </li>

        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isPackagesActive ? "active" : ""}`}
            onClick={() => handleDropdownClick("Packages")}
            style={{ cursor: "pointer" }}
          >
            <img src={Packages} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Packages</span>

                <span className="ms-auto">
                  {isOpen("Packages") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("Packages") && (
            <ul className="submenu">
              <li
                onClick={() =>
                  handleClick("holiday-packages", "/holiday-packages")
                }
                className={isActive("holiday-packages") ? "active" : ""}
              >
                <img src={Threeline} className="menu-icon-img" alt="" />

                <span className="menu-text">My Packages</span>
              </li>

              <li
                onClick={() =>
                  handleClick(
                    "create-holiday-package",
                    "/create-holiday-package",
                  )
                }
                className={isActive("create-holiday-package") ? "active" : ""}
              >
                <img src={plusgray} className="menu-icon-img" alt="" />

                <span className="menu-text">Create Package</span>
              </li>
            </ul>
          )}
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("holiday-bookings") ? "active" : ""
            }`}
            onClick={() => handleClick("holiday-bookings", "/holiday-bookings")}
          >
            <img src={Bookings} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Bookings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("holiday-revenue") ? "active" : ""}`}
            onClick={() => handleClick("holiday-revenue", "/holiday-revenue")}
          >
            <img src={Ruppe2} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Revenue & Payouts</span>}
          </div>
        </li>
        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("holiday-settings") ? "active" : ""
            }`}
            onClick={() => handleClick("holiday-settings", "/holiday-settings")}
          >
            <img src={Setting} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Settings</span>}
          </div>
        </li>
        {/* <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("support-tickets") ? "active" : ""
            }`}
            onClick={() => handleClick("support-tickets", "/requests")}
          >
            <img src={Headset} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Support & Ticket</span>}
          </div>
        </li> */}
      </ul>
    </div>
  );
};

export default HolidayPackageSidebar;
